// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Jx-z","tooltipWrapper":"Kx-z","icon":"Lx-z","tooltip":"Mx-z","content":"Nx-z"};